import React from 'react'
import { string, node } from 'prop-types'
import styled from 'styled-components'
import { Link } from 'gatsby'

import * as spacing from 'styles/spacing'
import { media, mediaDown } from 'styles/media'
import { fontSizes, fontWeights } from 'styles/typography'
import { white, black } from 'styles/colors'
import { cover } from 'styles/global'

import Button from 'components/button/Button'

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  background-color: ${white};
  box-shadow: 0px 3px 9px rgba(0, 0, 0, 0.11);

  ${mediaDown.medium`
    text-align: center;
  `};
`

const FigureWrap = styled(Link)`
  position: relative;
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  color: ${white};
  padding: ${spacing.large};
  flex: 1;
  background-color: ${black};

  &:before {
    content: '';
    display: block;
    padding-bottom: 67%;
    width: 100%;
  }

  ${media.medium`
    min-height: 266px;
  `};

  ${media.large`
    padding: ${spacing.xLarge};
  `};
`

const Figure = styled.img`
  ${cover('absolute')};
  object-fit: cover;
`

const NameWrap = styled.div`
  margin-bottom: ${spacing.tiny};

  ${media.medium`
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
  `};

  ${media.large`
    margin-bottom: ${spacing.small};
  `};
`

const Name = styled.span`
  display: block;
  font-size: ${fontSizes.small};
  font-weight: ${fontWeights.bold};
  color: ${black};

  ${media.medium`
    flex: 1;
    padding-right: ${spacing.medium};
  `};
`

const Content = styled.div`
  padding: ${spacing.medium};
  display: flex;
  flex-direction: column;
  width: 100%;

  ${media.small`
    padding: ${spacing.large};
  `};

  ${media.large`
    padding-bottom: ${spacing.xLarge};
  `};
`

const Price = styled.span`
  color: ${black};
  font-weight: ${fontWeights.medium};
`

const Footer = styled.footer`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: auto;
`

const AddButton = styled(Button)`
  ${media.small`
    width: 154px;
  `};

  ${mediaDown.small`
    padding: 0;
    width: 100%;
  `};
`

const Description = styled.p`
  font-size: ${fontSizes.tiny};
  color: ${black};
`

const MultipackThumbnail = ({ name, description, slug, price, link }) => {
  return (
    <Container>
      <FigureWrap to={link}>
        <Figure src={`${process.env.BASE_PATH}/images/products/epod/multipack/${slug}.jpg`} />
      </FigureWrap>

      <Content>
        <NameWrap>
          <Name>Mix & Match: {name}</Name>
          <Price className="u-hide-medium-down">{price}</Price>
        </NameWrap>
        <Description>{description}</Description>

        <Footer>
          <AddButton className="u-hide-medium-up" to={link} theme="secondary">
            Create - {price}
          </AddButton>
          <AddButton className="u-hide-medium-down" to={link} theme="primary">
            Create
          </AddButton>
        </Footer>
      </Content>
    </Container>
  )
}

MultipackThumbnail.propTypes = {
  slug: string.isRequired,
  name: string.isRequired,
  description: node.isRequired,
  price: string.isRequired,
  link: string.isRequired
}

export default MultipackThumbnail
